/* eslint-disable */
// @ts-nocheck

import React from "react";
import { TextInput, FormLabel } from "@carbon/react";
import FieldTooltip from "../tooltip/Tooltip";

interface IProps {
  id?: string;
  type?: "text" | "password";
  labelText: string;
  placeholder?: string;
  disabled?: boolean;
  onChange: (value: string) => void;
  value?: string;
  invalid?: boolean;
  invalidText?: string;
  tooltipText?: string;
  required?: boolean;
}

const TextField = ({
  id,
  type = "text",
  labelText,
  placeholder,
  disabled = false,
  onChange,
  value,
  invalid = false,
  invalidText,
  tooltipText,
  required,
}: IProps) => {
  return (
    <div className="form-wrapper">
      <div className="form-label" data-cy="textFieldForm">
        <FormLabel data-cy={`${labelText.replaceAll(" ", "")}-textlabel`}>
          {labelText} {required == true ? "*" : null}
        </FormLabel>
        {tooltipText ? (
          <FieldTooltip
            label={tooltipText}
            fieldName={`${labelText.replaceAll(" ", "")}-`}
          />
        ) : null}
      </div>
      <TextInput
        id={id}
        labelText=""
        type={type}
        onChange={(event: { target: { value: string } }) => {
          onChange(event.target.value);
        }}
        placeholder={placeholder || labelText}
        value={value}
        disabled={disabled}
        invalid={invalid}
        invalidText={invalidText}
        required={required}
        data-cy={`${labelText.replaceAll(" ", "")}-input`}
      />
    </div>
  );
};

export default TextField;
